import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  loadCotsTypeFailure,
  loadCotsTypes, loadCotsTypeSuccess,
  loadMaterialFamilies,
  loadMaterialFamiliesFailure,
  loadMaterialFamiliesSuccess,
  loadOrganizations,
  loadOrganizationsFailure,
  loadOrganizationsSuccess,
  loadShapeTypes, loadShapeTypesFailure,
  loadShapeTypesSuccess

} from "./global-config-dropdown.action";
import {AppState} from "../../../shared/state/app.state";
import {GlobalConfigService} from "../../data-access/global-config.service";


@Injectable()
export class GlobalConfigDropdownEffects {
  loadMaterialFamilies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMaterialFamilies),
      switchMap((action) =>
        this.globalConfigService.get('materialFamily')
          .pipe(
            map((materialFamilies) => loadMaterialFamiliesSuccess({materialFamilies: materialFamilies})),
            catchError((error) => of(loadMaterialFamiliesFailure({ error })))
          )
      )
    )
  );

  loadOrganizations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadOrganizations),
      switchMap((action) =>
        this.globalConfigService.get('organization')
          .pipe(
            map((organizations) => loadOrganizationsSuccess({organizations: organizations})),
            catchError((error) => of(loadOrganizationsFailure({ error })))
          )
      )
    )
  );

  loadShapeTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadShapeTypes),
      switchMap((action) =>
        this.globalConfigService.get('shapeType')
          .pipe(
            map((shapeTypes) => loadShapeTypesSuccess({shapeTypes: shapeTypes})),
            catchError((error) => of(loadShapeTypesFailure({ error })))
          )
      )
    )
  );

  loadCotsTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCotsTypes),
      switchMap((action) =>
        this.globalConfigService.get('cotsType')
          .pipe(
            map((cotsTypes) => loadCotsTypeSuccess({cotsTypes: cotsTypes})),
            catchError((error) => of(loadCotsTypeFailure({ error })))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private globalConfigService: GlobalConfigService
  ) {}
}
